import React from 'react';
import styled from 'styled-components';

function TextArea({id, label, placeholder, value, onChange, invalid, ...props}) {
  if (!id && label) {
    throw new Error('TextArea with a label must also have an ID');
  }

  return (
    <>
      {label && <Label htmlFor={id}>{label}</Label>}
      <Container id={id} value={value} placeholder={placeholder} onChange={onChange} invalid={invalid} {...props} />
    </>
  );
}

const Container = styled.textarea`
  flex: 1;
  display: block;
  width: 100%;
  height: calc(4.5rem + 2px);
  padding: .375rem .75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;

  :disabled {
    background-color: #EBEBEB;
    opacity: 1;
  }

  :focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
  }

  // Handle the large variant of inputs
  ${props => {
    if (props.large) {
      return `
        height: calc(5.75rem + 2px);
        padding: .5rem 1rem;
        font-size: 1.25rem;
        line-height: 1.5;
        border-radius: .3rem;
      `;
    }
  }}

  // Handle validation state
  ${props => {
    if (props.invalid) {
      return `
        border-color: #dc3545 !important;

        :focus {
          box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, .25);
        }
      `;
    }
  }}
`;

const Label = styled.label`
  ${props => {
    if (props.labelPosition === 'top') {
      return `
        display: block;
        margin-bottom: 0.5rem;
      `;
    }

    return `
      word-wrap: nowrap;
      margin-right: 1rem;
      display: flex;
      align-items: center;
    `;
  }}
`;

export default TextArea;